/** Lokalna średnia czasu zapisu klatki (Gemini × N + extract). */
const STORAGE_KEY = "media.still_ai.avg_v1";
const EXTRACT_MS = 2_500;
const MS_PER_GEMINI = 12_000;

type AvgBucket = { avgMs: number; n: number };
type AvgStore = Record<string, AvgBucket>;

export function countStillAiCalls(opts: {
  removeCaptions: boolean;
  enhanceQuality: boolean;
  fillSquare: boolean;
}): number {
  let n = 0;
  if (opts.removeCaptions) n += 1;
  if (opts.enhanceQuality) n += 1;
  if (opts.fillSquare) n += 1;
  return n;
}

export function stillAiStepLabels(opts: {
  removeCaptions: boolean;
  enhanceQuality: boolean;
  fillSquare: boolean;
}): string[] {
  const labels: string[] = ["Klatka"];
  if (opts.removeCaptions) labels.push("Napisy");
  if (opts.enhanceQuality) labels.push("Upscale");
  if (opts.fillSquare) labels.push("Kwadrat");
  return labels;
}

function loadStore(): AvgStore {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as AvgStore;
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

function saveStore(store: AvgStore) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch {
    /* ignore quota */
  }
}

export function estimateStillAiMs(geminiCalls: number): { expectedMs: number; samples: number } {
  const key = String(Math.max(0, geminiCalls));
  const bucket = loadStore()[key];
  const fallback = EXTRACT_MS + Math.max(0, geminiCalls) * MS_PER_GEMINI;
  if (bucket && bucket.n > 0 && bucket.avgMs > 0) {
    return { expectedMs: Math.max(3_000, Math.round(bucket.avgMs)), samples: bucket.n };
  }
  return { expectedMs: Math.max(3_000, fallback), samples: 0 };
}

export function recordStillAiMs(geminiCalls: number, durationMs: number) {
  const ms = Math.max(1_000, Math.round(durationMs));
  const key = String(Math.max(0, geminiCalls));
  const store = loadStore();
  const prev = store[key];
  if (!prev || prev.n <= 0) {
    store[key] = { avgMs: ms, n: 1 };
  } else {
    const n = Math.min(40, prev.n + 1);
    const avgMs = Math.round(prev.avgMs + (ms - prev.avgMs) / n);
    store[key] = { avgMs, n };
  }
  saveStore(store);
}
